package com.xtream.ui.tv.presentation.home

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import coil3.Bitmap
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.BaseTrending


@Composable
fun HomeTvCarousel(
    modifier: Modifier = Modifier,
    items:List<BaseStream>,
    color: Color,
    onClick:(item: BaseTrending)->Unit,

    onBitmapLoaded: ((url: String?, Bitmap) -> Unit)? = null
){
   /* val tmdbViewModel: TmdbViewModel = koinViewModel()
    val titleLogo by tmdbViewModel.movieLogo.collectAsStateWithLifecycle()
    val infos = items.filterIsInstance<BaseTrending>()
    @OptIn(ExperimentalMaterial3Api::class)
    val carouselState = rememberCarouselState()

     TvCarousel(
        carouselState=carouselState,
        modifier = modifier
            .background(color, shape = MaterialTheme.shapes.medium)
        ,
        items = infos,
        onClick = { item ->
            onClick(item ) }
    ) { index,focused, item ->

        CarouselItem(
            Modifier
                .padding(
                    24.dp
                )
                .fillMaxHeight(),
            focused = focused,
            title = item.name,
            titleLogo = titleLogo,

           description = item.overview,
            genre = null,
            rating = item.voteAverage?.toString(),
            year = item.releaseDate,
            backdrop = item.backdrop.addTMDBPrefixImageURL(),
            onBitmapLoaded = onBitmapLoaded

        )
    }





    @OptIn(ExperimentalTvMaterial3Api::class)

     LaunchedEffect(carouselState) {
        snapshotFlow { carouselState.activeItemIndex }
            .distinctUntilChanged()
            .collect { index ->
                val item = infos.getOrNull(index)?.id ?: return@collect
                tmdbViewModel.loadMovieLogo(item.toString())

            }
    }*/
}
